import { Outlet } from "react-router-dom";
import { checkRole } from "../../stores/jotai/base";
import NotFoundPage from "../not-found";
import { Box } from "@mui/material";
import { ADMIN_VALID_EMAIL } from "../../constants";

const SuperAdminVerify = ({ base }) => {
  const isCI = process.env.NEXT_PUBLIC_NODE_ENV === "ci";
  let innerContent = <Outlet />;
  if (isCI) {
    const isSystemAdministrator = checkRole(base,"isSystemAdministrator") && ADMIN_VALID_EMAIL.includes(base.user.email);
    if (!isSystemAdministrator) {
      innerContent = <NotFoundPage />;
    }
  }

  return (
    <Box
      my={3}
      sx={{
        height: "100%",
        overflowY: "auto",
        paddingBottom: 4
      }}
    >
      <Box mx={3}>{innerContent}</Box>
    </Box>
  );
};

export default SuperAdminVerify;
